import styled from 'styled-components';

export const FilterHeading = styled.p`
  // font-size: clamp(17px, 2vw, 22px);
  // color: #414141;
  // padding: 10px 10px 0;
  // font-weight: bold;

  font-size: clamp(1em, 3vw, 1.3em);
  padding: 20px 10px 0px;
  color: #414141;
  position: relative;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 10px;
  letter-spacing: 1px;

  @media (min-width: 768px) {
    padding: 20px 10px 0px;
    width: 80%;
    margin: auto;
  }
  text-transform: UPPERCASE;
`;
export const FilterTopHeading = styled.h1`
  font-size: clamp(18px, 2vw, 26px);
  color: #414141;
  padding: 10px 10px 0;
  display: flex;
  justify-content: center;

  @media (min-width: 768px) {
    padding: 20px 10px 0px;
    width: 80%;
    margin: auto;
  }
  text-transform: capitalize;
`;
export const SubCategoryFilterSectionNew = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding: 0px 12px;
  gap: 12px;
  place-items: center;
  @media (min-width: 768px) {
    width: 80%;
    margin: auto;
    gap: 20px 30px;
  }
`;
export const SubCategoryFilterSection = styled.nav`
  overflow-x: scroll;
  will-change: transform;
  scroll-behavior: smooth;
  display: flex;
  align-items: flex-start;
  gap: 20px;
  min-width: 100vw;
  &::-webkit-scrollbar {
    display: none;
  }
  box-shadow: 0px 1px 10px -1px #1111117d;
  transition: all 0.4s linear;
  background: white;
  padding: 10px;
  position: fixed;
  width: 100%;
  // position: ${(props) => (props?.showSticky ? 'sticky' : 'fixed')};
  top: ${(props) =>
    props?.showSticky
      ? props.showHeader == '-56px'
        ? '0px'
        : '64px'
      : '-180px'};
  z-index: 99;
  @media (min-width: 768px) {
    display: none;
  }
`;

export const SubCategoryFilterItem = styled.div`
  .imgWrapper {
    position: relative;
    padding-top: 100%;
    background-image: linear-gradient(
      to right,
      #f2f3ea 0%,
      rgba(255, 255, 255, 0) 100%
    );
    border-radius: 8px;
  }
  p {
    font-size: 12px;
    color: #333;
    text-align: center;
    padding-top: 6px;
    font-weight: 500;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  flex-shrink: 0;
  flex-basis: 24%;
  &.active {
    opacity: 0.4;
  }
  @media (min-width: 768px) {
    flex-basis: 10%;
  }
`;
